module.exports = __webpack_public_path__ + "static/media/analgesic.1c670b4e.png";